<template>
  <div class="verification" v-if="linkType">
    <img v-if="['verified', 'already_verified'].includes(linkType)" class="verification-icon" src="~@/assets/verified.svg" alt="Email verified">
    <h1 class="verification-title" v-text="$t(`verification.title_${linkType}`)"></h1>
    <div class="verification-text" v-html="$t(`verification.text_${linkType == 'already_verified' ? 'verified' : linkType}`)"></div>
    <button
      class="verification-btn"
      v-loading="loading"
      v-if="linkType == 'expired'" @click="handleResend">
      <span v-text="$t('verification.btn_resend')"></span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Verification',
  data() {
    return {
      loading: false,
      linkType: ''
    }
  },
  watch: {
    $route() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      let linkType = ''
      const { query } = this.$route

      switch (query.result) {
        case 'success':
          // verified
          linkType = 'verified'
          break
        case 'verification-request-not-found':
          //verificationRequest not found
          linkType = 'failed'
          break
        case 'user-not-found':
          // user not found
          linkType = 'failed'
          break
        case 'used-or-expired':
          // user expired
          linkType = 'expired'
          break
        case 'already-verified':
          // user already verified
          linkType = 'already_verified'
          break
        case 'fcm-token-not-found':
          // verificationRequest.fcmToken not found
          linkType = 'mobile_required'
          break
        case 'firebase-notification-error':
          // error during firebase notification sending
          linkType = 'mobile_required'
          break
        case 'mobile-required':
          linkType = 'mobile_required'
          break

        default:
          linkType = 'failed'
          break
      }

      this.linkType = linkType
    },
    handleResend() {
      const { query } = this.$route

      this.loading = true

      this.$http.post('/security-code/', query).then(() => {
        this.loading = false
        this.$message({
          type: 'success',
          duration: 10 * 1000,
          message: this.$t('verification.msg_send_email_success')
        })
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    }
  }
}
</script>

<style lang="less">
  @import url('~@/styles/var.less');

  .verification {
    flex: 1;
    margin: 120px auto 0;
    padding: 16px;
    text-align: center;
    font-family: 'Roboto';
    line-height: 24px;
    letter-spacing: 0.15px;
    background-color: var(--background-color, @background-color);
    & &-title {
      margin: 0 0 16px;
      color: var(--title-color, @dark);
      font-weight: 500;
      font-size: 24px;
      text-align: center;
    }
    & &-text {
      margin: 0 0 36px;
      color: @grey-600;
      font-size: 16px;
      text-align: center;
      letter-spacing: 0.15px;
    }
    & &-icon {
      display: inline-block;
      width: 112px;
      height: 113px;
      margin: -42px 0 36px;
    }
    & &-btn {
      width: 340px;
      height: 50px;
      line-height: 50px;
      color: @white;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      text-align: center;
      letter-spacing: 1.25px;
      border-radius: 4px;
      background-color: #F28E22;
      text-transform: uppercase;
      &:hover {
        opacity: .8;
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .verification {
      margin: 120px 0 0;
      & &-btn {
        width: 100%;
      }
    }
  }
</style>
